import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ButtonComponent } from '../../button/button.component';
import { CartProductsTableComponent } from '../../cart-products-table/cart-products-table.component';
import { EmptyListInfoComponent } from '../../empty-list-info/empty-list-info.component';
import { TranslateService } from '@ngx-translate/core';
import { ResidentCart } from '../../../models/cart.model';
import { Resident } from '../../../models/resident.model';

@Component({
  selector: 'app-cart-section',
  templateUrl: './cart-section.component.html',
  styleUrls: ['../list-of-needs-dialog.component.scss'],
  imports: [
    MatIconModule,
    MatSelectModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonComponent,
    CartProductsTableComponent,
    EmptyListInfoComponent,
  ],
})
export class CartSectionComponent {
  @Input() residentCart!: ResidentCart | null;
  @Input() residentControl!: FormControl<Resident>;
  @Input() closeDialog: () => void = () => {};

  constructor(private translateService: TranslateService) {}

  get noProductsText() {
    return this.translateService.instant('cartModal.noProducts');
  }
}
